import { useEffect } from 'react'
import useAxiosPrivate from '../../api/hooks/useAxiosPrivate'
import { DashboardDataThirdPartyCollectors } from '../../utils/types/dashboardTypes'
import usePollingQuery from '../usePollingQuery'
import { useAuthContext } from '../../context/auth/AuthContextProvider'

const useFetchThirdPartyCollectorsDashboardData = (refresh: boolean) => {
  const { user } = useAuthContext()
  const axiosPrivate = useAxiosPrivate()

  const { data, isLoading, error, refetch, startRefresh, stopRefresh } =
    usePollingQuery({
      queryKey: ['dashboardThirdPartyCollectors'],
      queryFn: async () => {
        const response = await axiosPrivate.get(
          'api/dashboard-third-party-collectors'
        )
        return response.data as DashboardDataThirdPartyCollectors
      },
      intervalMs: 60_000,
    })

  useEffect(
    () => {
      if (user.companyOptions.includes('MENU_JOBS_STATUS')) {
        if (refresh) {
          startRefresh()
        } else {
          refetch()
        }
      }

      return () => stopRefresh()
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )

  return {
    dashboardData: data,
    handleFetchDashboardData: refetch,
    isLoading,
    stopRefresh,
    startRefresh,
    error,
  }
}

export default useFetchThirdPartyCollectorsDashboardData
